/** @format */

import { END_POINT } from "utils";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "./axios";
import {
  PaymentVoucherForm,
  PaymentVoucherQuery,
  PaymentVoucherUpdatePayload,
} from "types";

const buildQueryString = (params?: PaymentVoucherQuery) => {
  if (!params) return "";
  const search = new URLSearchParams();
  if (params.page) search.append("page", String(params.page));
  if (params.pageSize) search.append("limit", String(params.pageSize));
  if (params.search) search.append("q", params.search);
  const hasSort =
    Array.isArray(params.sortModel) && params.sortModel.length > 0;
  if (hasSort) {
    search.append("sort", JSON.stringify(params.sortModel));
  }
  const hasFilters =
    params.filterModel &&
    typeof params.filterModel === "object" &&
    Object.keys(params.filterModel).length > 0;
  if (hasFilters) {
    search.append("filters", JSON.stringify(params.filterModel));
  }
  const qs = search.toString();
  return qs ? `?${qs}` : "";
};

export const paymentVoucherService = {
  list: async (params?: PaymentVoucherQuery) => {
    try {
      const rs = await getRequest(
        `${END_POINT.PAYMENT_VOUCHERS.LIST}${buildQueryString(params)}`,
      );
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  show: async (id: number | string) => {
    try {
      const rs = await getRequest(`${END_POINT.PAYMENT_VOUCHERS.LIST}/${id}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  store: async (payload: PaymentVoucherForm) => {
    try {
      const rs = await postRequest(END_POINT.PAYMENT_VOUCHERS.LIST, payload);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  update: async (payload: PaymentVoucherUpdatePayload) => {
    try {
      const rs = await patchRequest(
        `${END_POINT.PAYMENT_VOUCHERS.LIST}/${payload.id}`,
        payload,
      );
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  destroy: async (id: number | string) => {
    try {
      const rs = await deleteRequest(`${END_POINT.PAYMENT_VOUCHERS.LIST}/${id}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
};
